import React from "react";
import {Outlet} from "react-router-dom";
import Menu from "routes/Menu";

const Administration = () => {
  Menu(8);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Administration;
